module.exports = __webpack_public_path__ + "static/media/Chris.54623099.jpg";